import SvgCheckSmall from '~/icons/CheckSmall'
import SvgInfo from '~/icons/Info'
import SvgWarning from '~/icons/Warning'

type InlineAlertProps = {
  variant?: 'informative' | 'positive' | 'notice' | 'negative' | 'neutral'
  title: string
  message: string
}

const alertStyles = {
  informative: 'border-primary-info',
  positive: 'border-primary-success',
  notice: 'border-primary-light',
  negative: 'border-primary-error',
  neutral: 'border-primary-black',
}

const alertIcon = {
  informative: <SvgInfo className="fill-primary-info" />,
  positive: <SvgCheckSmall className="bg-primary-success rounded-2xl fill-white" />,
  notice: <SvgWarning className="fill-primary-light" />,
  negative: <SvgWarning className="fill-primary-error" />,
  neutral: '',
}

const InlineAlert = ({ variant, title, message }: InlineAlertProps) => {
  return (
    <div
      className={`p-4 rounded-lg justify-between mb-6 bg-white border-2 border-solid ${alertStyles[variant ?? 'neutral']} flex`}
    >
      <div className="ml-3">
        <h3 className="text-base font-medium text-primary-black">{title}</h3>
        <div className="mt-2 text-sm text-gray-80">{message}</div>
      </div>
      <div className="flex-shrink-0">{variant && alertIcon[variant]}</div>
    </div>
  )
}

export default InlineAlert
